<template>
   <v-app id="inspire" :class="{ 'receipt-mobile-app': isReceiptMobile }">
      <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" v-model="drawer" fixed app>
         <v-list dense>
            <template v-for="item in items">
               <v-list-tile :key="item.text" :to="item.route">
                  <v-list-tile-action>
                     <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                     <v-list-tile-title>
                        {{ item.text }}
                     </v-list-tile-title>
                  </v-list-tile-content>
               </v-list-tile>
            </template>
         </v-list>
      </v-navigation-drawer>

      <v-toolbar class="app-toolbar" :clipped-left="$vuetify.breakpoint.lgAndUp" color="blue darken-3" dark app fixed>
         <v-toolbar-title class="app-toolbar__title ml-0 pl-3">
            <v-toolbar-side-icon aria-label="Åpne meny" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <span class="app-toolbar__mobile-title hidden-md-and-up">{{ mobileTitle }}</span>
            <span class="hidden-sm-and-down">Economy {{ buildVersion }}</span>
         </v-toolbar-title>

         <v-spacer></v-spacer>

         <v-btn icon large aria-label="Brukerprofil">
            <v-avatar size="32">
               <img v-if="picture && !pictureFailed" :src="picture" alt="" @error="pictureFailed = true" />
               <v-icon v-else color="white">account_circle</v-icon>
            </v-avatar>
         </v-btn>
      </v-toolbar>
      <v-content>
         <router-view></router-view>
      </v-content>
   </v-app>
</template>

<script>
import { getVersion } from "../config/version";
export default {
   data: () => ({
      dialog: false,
      drawer: null,
      pictureFailed: false,
      items: [
         { icon: "dashboard", text: "Dashboard", route: "/dashboard" },
         { icon: "camera_alt", text: "Send kvittering", route: "/receipts/new" },
         { icon: "import_export", text: "import transactions", route: "/import-transactions" },
         { icon: "upcoming", text: "Upcoming transactions", route: "/expected-transactions" },
         { icon: "inbox", text: "New transactions", route: "/" },
         // { icon: "credit_card", text: "Credit cards", route: "/credit-cards" },
       
         { icon: "event", text: "This month", route: "/month-view/current" },
         { icon: "event", text: "Last month", route: "/month-view/last" },
         { icon: "find_in_page", text: "Report", route: "/report" },
         { icon: "settings", text: "Categories", route: "/categories" },
         { icon: "work", text: "Rules", route: "/rules" },
         { icon: "power_settings_new", text: "Logout", route: "/logout" },
         // { icon: 'settings', text: 'Settings' },
      ],
   }),
   props: {
      source: String,
   },
   computed: {
      buildVersion() {
         return getVersion();
      },
      picture() {
         let user = this.$auth.getUser();
         if (user) {
            return user.picture;
         } else {
            return null;
         }
      },
      isReceiptMobile() {
         return this.$vuetify.breakpoint.smAndDown && this.$route.name === "newReceipt";
      },
      mobileTitle() {
         return this.$route.name === "newReceipt" ? "Send kvittering" : "myEconomy";
      },
   },
   created() {
      // if(this.$auth.isAuthenticated()){
      //   this.$store.dispatch('getNewTransactions');
      //   this.$store.dispatch('getCategories');
      //   this.$store.dispatch('getRules');
      //   this.$store.dispatch('getThisMonthsTransactions');
      //   this.$store.dispatch('getLastMonthsTransactions');
      // }
   },
};
</script>

<style>
html,
body {
   min-height: 100%;
   overscroll-behavior-y: none;
}

.app-toolbar__title {
   width: 300px;
}

@media (max-width: 600px) {
   .app-toolbar .v-toolbar__content {
      padding-right: 8px;
      padding-left: 4px;
   }

   .app-toolbar__title {
      display: flex;
      min-width: 0;
      width: auto;
      align-items: center;
      flex: 1 1 auto;
      padding-left: 0 !important;
   }

   .app-toolbar__mobile-title {
      overflow: hidden;
      font-size: 18px;
      font-weight: 500;
      text-overflow: ellipsis;
      white-space: nowrap;
   }

   .receipt-mobile-app .v-content {
      background: #ffffff;
   }

}

@media (max-width: 600px) and (display-mode: standalone) {
   .receipt-mobile-app .app-toolbar {
      height: calc(56px + env(safe-area-inset-top)) !important;
      padding-top: env(safe-area-inset-top);
   }

   .receipt-mobile-app .app-toolbar .v-toolbar__content {
      height: 56px !important;
   }

   .receipt-mobile-app .v-content {
      padding-top: calc(56px + env(safe-area-inset-top)) !important;
   }
}
</style>
